// Static meta tags for SmilesFlow
export const getMetaTags = () => {
  return {
    title: 'SmilesFlow | Branded Mini-Games That Capture Leads',
    description: 'Launch a branded arcade game in minutes. Share via QR code, link, or embed. Players compete on a live leaderboard and opt into your list. No app download.',
    siteName: 'SmilesFlow',
    domain: 'https://www.smilesflow.com',
    image: 'https://www.smilesflow.com/og-image.png',
    keywords: 'branded mini-games, campaign games, QR games, marketing games, live leaderboard, lead capture games, agency campaign tools, gamified marketing',
    author: 'SmilesFlow',
    twitterSite: '@smilesflow',
    themeColor: '#F1C40F' // Retro arcade yellow
  };
};

// Initialize SEO on page load
export const initializeDynamicSEO = () => {
  // Set the favicon
  const favicon = document.querySelector('link[rel="icon"]') || document.querySelector('link[rel="shortcut icon"]');
  if (favicon) {
    favicon.href = '/transSmilesFlowFavicon.png';
  }

  // Set the document title
  document.title = getMetaTags().title;
}; 